<template>
    <div class="breadcrumbs" v-if="links.length">
        <div class="breadcrumbs__inner">
             <router-link class="breadcrumbs__item" to="/home">
                <svg class="icon icon_color_light-gray">
                    <use xlink:href="/img/sprites/icons-sprite.svg#icon-home"></use>
                </svg>
            </router-link>
            <component :is="item.path !== route.path ? 'router-link' : 'div'"
                v-for="item in links"
                :key="item.name"
                class="breadcrumbs__item"
                :to="{path: item?.path}"
            >
                {{ item.title }}
            </component>
        </div>
    </div>
</template>

<script setup>
    import {computed} from "vue";
    import {useStore} from "vuex";
    import { useRoute } from "vue-router";

    const route = useRoute();
    const store = useStore();
    const links = computed(() => {
        return store.getters.breadcrumbs
    })
</script>
<style lang="scss" scoped>
    @import './scss/breadcrumbs.scss';
</style>
